import { render, staticRenderFns } from "./VoucherDemographic.vue?vue&type=template&id=0d4578c4&"
import script from "./VoucherDemographic.vue?vue&type=script&lang=js&"
export * from "./VoucherDemographic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports